document.addEventListener('DOMContentLoaded', () => {
    const animatedElements = document.querySelectorAll('[data-animation]');
    // Intersection Observer
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const element = entry.target;
                    const animation = element.getAttribute('data-animation');
                    element.classList.add('opacity-100', 'transform-none', `animate-${animation}`);
                    observer.unobserve(element); // Stop observing after animation
                }
            });
        },
        { threshold: 0.1 } // Trigger when 10% of the element is visible
    );

    animatedElements.forEach((el) => observer.observe(el));
});
